<template>
  <v-layout row wrap class="ch-search-filter-wrapper">
    <v-flex xs12 class="ch-search-filter pb-0 pt-0">
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-container fluid grid-list-lg class="pt-0 pb-0">
          <v-layout row wrap class="filter-wrap">
            <button class="form-clear-btn" @click.prevent="clearAllField">
              <i class="fas fa-eraser"></i>
              <span>CLEAR</span>
            </button>
            <v-flex xs2 class="pl-0 pr-0">
              <v-select
                :items="filterTypeItems"
                v-model="filterTypeItemInput"
                label="Type"
                bottom
                autocomplete
                single-line
                hide-details
                clearable
              ></v-select>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
  import _ from 'lodash';
  import { doorlocksLogsEventBus } from '@/components/admin/doorlocks/doorlocksLogsEventBus';
  import logFormatter from '@/components/admin/doorlocks/doorlockLogFormatter';

  export default {
    data() {
      return {
        id: {
          hotel_id: '',
          building_id: '',
        },
        // NOTE: 모든 검색어
        allSearch: {
          type: {
            search: null,
            searchCategory: 'log_type',
          },
        },
        valid: true,
        // NOTE: 렌더링 될 변수들
        filterType: null,
        filterTypeItems: [],
      };
    },
    methods: {
      clearAllField() {
        this.$refs.form.reset();
      },
      /**
       * @description 사용자가 입력을 기다리는 시간(밀리세컨드) 입니다.
       * @param { Object } object, this.allSearch
       */
      getInputValue: _.debounce((obj) => {
        doorlocksLogsEventBus.$emit('customFilter', obj);
      }, 500),
    },
    computed: {
      filterTypeItemInput: {
        get() {
          return this.filterType;
        },
        set(newValue) {
          this.filterType = newValue;
          this.allSearch.type.search = newValue;
          doorlocksLogsEventBus.$emit('customFilter', this.allSearch);
        },
      },
    },
    mounted() {
      this.filterTypeItems = logFormatter.getFormatTypeList();
      doorlocksLogsEventBus.$on('reloadList', () => {
        this.clearAllField();
      });
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/doorlocks/DoorlockLogsFilter.vue